// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*  imported from Breadcrumb.module.scss  */
.Breadcrumb-module-Root_2dE {
  font-family: var(--control-font-family); }

.Breadcrumb-module-Item_xNt {
  display: flex;
  align-items: center; }

.Breadcrumb-module-Siblings_26G {
  pointer-events: none;
  fill: var(--breadcrumbs-color-siblings); }

.Breadcrumb-module-Separator_XLG {
  margin-right: var(--breadcrumbs-spacing-x-separator);
  margin-left: var(--breadcrumbs-spacing-x-separator);
  fill: var(--breadcrumbs-color-separator); }

.Breadcrumb-module-Link_2JF {
  font-size: var(--breadcrumbs-font-size);
  line-height: 1;
  text-decoration: none;
  text-transform: uppercase;
  color: var(--breadcrumbs-color); }
  .Breadcrumb-module-Link_2JF[aria-current='page'] {
    font-weight: var(--breadcrumbs-font-weight-current);
    pointer-events: none;
    color: var(--breadcrumbs-color-current); }
  .Breadcrumb-module-Link_2JF:hover {
    color: var(--breadcrumbs-color-hover); }
`, "",{"version":3,"sources":["webpack://./node_modules/@npm-registry/eapteka-ui/es/components/Breadcrumbs/Breadcrumb/Breadcrumb.css"],"names":[],"mappings":"AAAA,2CAA2C;AAC3C;EACE,uCAAuC,EAAE;;AAE3C;EACE,aAAa;EACb,mBAAmB,EAAE;;AAEvB;EACE,oBAAoB;EACpB,uCAAuC,EAAE;;AAE3C;EACE,oDAAoD;EACpD,mDAAmD;EACnD,wCAAwC,EAAE;;AAE5C;EACE,uCAAuC;EACvC,cAAc;EACd,qBAAqB;EACrB,yBAAyB;EACzB,+BAA+B,EAAE;EACjC;IACE,mDAAmD;IACnD,oBAAoB;IACpB,uCAAuC,EAAE;EAC3C;IACE,qCAAqC,EAAE","sourcesContent":["/*  imported from Breadcrumb.module.scss  */\n.Breadcrumb-module-Root_2dE {\n  font-family: var(--control-font-family); }\n\n.Breadcrumb-module-Item_xNt {\n  display: flex;\n  align-items: center; }\n\n.Breadcrumb-module-Siblings_26G {\n  pointer-events: none;\n  fill: var(--breadcrumbs-color-siblings); }\n\n.Breadcrumb-module-Separator_XLG {\n  margin-right: var(--breadcrumbs-spacing-x-separator);\n  margin-left: var(--breadcrumbs-spacing-x-separator);\n  fill: var(--breadcrumbs-color-separator); }\n\n.Breadcrumb-module-Link_2JF {\n  font-size: var(--breadcrumbs-font-size);\n  line-height: 1;\n  text-decoration: none;\n  text-transform: uppercase;\n  color: var(--breadcrumbs-color); }\n  .Breadcrumb-module-Link_2JF[aria-current='page'] {\n    font-weight: var(--breadcrumbs-font-weight-current);\n    pointer-events: none;\n    color: var(--breadcrumbs-color-current); }\n  .Breadcrumb-module-Link_2JF:hover {\n    color: var(--breadcrumbs-color-hover); }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
